import React, { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { AuthState } from "../api/authApiClient";
import { AuthContext } from "../contexts/AuthProvider";
import { usePageViewTracking } from "@/hooks/useAnalytics";

export const PublicRoute = () => {
  const { authState } = useContext(AuthContext);

  // Track page views when route changes
  usePageViewTracking();

  return authState === AuthState.AUTHORIZED ? <Navigate to="/" /> : <Outlet />;
};
